import R from 'ramda'
import { AC_STATUS_FILTERS } from '../../server/constants'

import {
  PAGES,
  AUTH_API_URL
} from '../constants'

import * as page from './page'

export const statePath = ['pages', PAGES.INSTITUTIONS]
export const activationCodesStatePath = (institutionId) => ['pages', PAGES.INSTITUTIONS, 'acsByInstId', institutionId]

export const create = ({
  payload = {}
}) => page.createOne({payload, statePath})

export const patch = ({
  institutionId,
  payload = {}
}) => page.modifyOne({
  statePath,
  _id: institutionId,
  payload
})

export const deactivate = ({
  institutionId
}) => page.deactivateOne({
  statePath,
  _id: institutionId
})

export const remove = ({
  institutionId,
  pageNum = 1,
  perPage = 20
}) => page.removeOne({
  statePath,
  _id: institutionId,
  pageNum,
  perPage
})

export const refresh = ({
  institutionId
}) => page.fetchOne({
  statePath,
  _id: institutionId
})

export const refreshList = ({
  pageNum = 1,
  perPage = 20,
  term = ''
}) => page.fetchList({
  statePath,
  query: {pageNum, perPage, term}
})

export const fetchAutocompleteSuggestions = ({term, pageNum}) => page.fetchAutocompleteSuggestions({
  statePath,
  term,
  pageNum
})

export const setAutocompleteSelections = (selections) => page.setAutocompleteSelections({
  statePath,
  selections
})

export const clearAutocompleteSuggestions = () => page.clearAutocompleteSuggestions({
  statePath
})

// notes
export const addNote = ({
  institutionId,
  payload = {}
}) => page.addNote({
  statePath,
  _id: institutionId,
  payload
})

export const removeNote = ({
  institutionId,
  noteId
}) => page.removeNote({
  statePath,
  noteId,
  _id: institutionId
})

// Inst License Pools
export const postLicensePool = ({
  institutionId,
  payload = {}
}) => R.merge(page.parts.postOne, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/pools`,
  _id: institutionId,
  statePath,
  payload
});

export const patchLicensePool = ({
  institutionId,
  licensePoolId,
  payload = {}
}) => R.merge(page.parts.patchOne, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/pools/${licensePoolId}`,
  _id: institutionId,
  statePath,
  payload
});

export const upgradeLicensePool = ({
  institutionId,
  licensePoolId,
}) => R.merge(page.parts.postOne, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/pools/${licensePoolId}/upgrade`,
  _id: institutionId,
  statePath
});

export const deactivateLicensePool = ({
  institutionId,
  licensePoolId
}) => R.merge(page.parts.deleteOne, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/pools/${licensePoolId}`,
  _id: institutionId,
  statePath
});

export const addLicensePoolSublicense = ({
  institutionId,
  licensePoolId,
  payload
}) => R.merge(page.parts.postOne, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/pools/${licensePoolId}/sublicenses`,
  _id: institutionId,
  statePath,
  payload
});

export const removeLicensePoolSublicense = ({
  institutionId,
  licensePoolId,
  sublicenseId
}) => R.merge(page.parts.deleteOne, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/pools/${licensePoolId}/sublicenses/${sublicenseId}`,
  _id: institutionId,
  statePath
});

// Inst. Keys
export const removeKeyedSessionMachine = ({
  institutionId,
  keyId, // subscriptions, max7, max8 etc
  // source, // subscriptions, max7, max8 etc
  machineId
}) => R.merge(page.parts.deleteOne, {
  // url: `${AUTH_API_URL}/institutions/${institutionId}/licenses/${source}/machines/${machineId}`,
  url: `${AUTH_API_URL}/institutions/${institutionId}/keys/${keyId}/machines/${machineId}`,
  statePath,
  _id: institutionId
})

export const deactivateKey = ({
  institutionId,
  keyId
}) => R.merge(page.parts.deleteOne, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/keys/${keyId}`,
  _id: institutionId,
  statePath
})

export const postKey = ({
  institutionId,
  payload = {}
}) => R.merge(page.parts.postOne, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/keys`,
  _id: institutionId,
  statePath,
  payload
})

// Inst. Activation Codes
export const activationCodesDeactivate = ({
  institutionId,
  licenseId
}) => R.merge(page.parts.deleteOne, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/activationcodes/${licenseId}`,
  // _id: licenseId,   // maybe it is better to NOT set the _id here and let the whole AC list show a loading
  statePath: activationCodesStatePath(institutionId)
})

export const activationCodesRefreshList = ({
  institutionId,
  pageNum = 1,
  perPage = 20,
  term = '',
  showExpired = false,
  status = AC_STATUS_FILTERS.ALL
}) => R.merge(page.parts.getList, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/activationcodes`,
  statePath: activationCodesStatePath(institutionId),
  query: {pageNum, perPage, term, showExpired, status}
})

// Inst Invites
export const postInvite = ({
  institutionId,
  payload = {}
}) => R.merge(page.parts.postOne, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/invites`,
  _id: institutionId,
  statePath,
  payload
});

export const removeInvite = ({
  institutionId,
  inviteId
}) => R.merge(page.parts.deleteOne, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/invites/${inviteId}`,
  _id: institutionId,
  statePath
});



// WEBPACK FOOTER //
// ./webAdmin/actions/institutions.js